window.addEventListener('DOMContentLoaded', function() {
  /**
   * 点击购买打开变体弹窗
   */
  const buyNowFormDoms = document.querySelectorAll('[data-watt-buy-now]')
  if (buyNowFormDoms.length > 0) {
    buyNowFormDoms.forEach(function(item) {
      const targetPathDom = item.querySelector('[data-prod-url]')
      if (!targetPathDom) return

      const prodPath = targetPathDom.getAttribute('data-prod-url')
      if (!prodPath) return
      item.addEventListener('submit', function(event) {
        event.preventDefault()
        if (!window.wattcycle) {
          window.location.href = prodPath
          return
        }

        const loadingDom = window.wattcycle.getLoadingDom(item)
        window.wattcycle.setLoading(loadingDom, true)

        window.wattcycle.fetchSection(prodPath, 'prod-option')
          .then(function(html) {
            if (!html) {
              window.location.href = prodPath
              return
            }

            if (window.wattPushbar) {
              let direction = 'right'
              if (window.innerWidth <= 900) {
                direction = 'bottom'
              }
              window.wattPushbar.open(direction, html, function(sideDom) {
                  window.wattcycle.initShoppingOperation(sideDom)
              })
            } else {
              window.location.href = prodPath
            }
          })
          .catch(function() {
            window.location.href = prodPath
          }).finally(function() {
            window.wattcycle.setLoading(loadingDom, false)
          })
      })
    })
  }

    // 初始化倒计时
    document.querySelectorAll('[data-watt-cd-timer]').forEach(function (container) {
      var timerEl = container.querySelector('[data-watt-cd-data]');
      if (!timerEl) return;

      var endTimeStr = timerEl.getAttribute('data-end-time');
      var shopOffsetStr = timerEl.getAttribute('data-shop-offset');
      if (!endTimeStr || !shopOffsetStr) return;

      function parseOffsetToMinutes(offsetStr) {
        var sign = offsetStr[0] === '-' ? -1 : 1;
        var hours = parseInt(offsetStr.slice(1, 3), 10);
        var minutes = parseInt(offsetStr.slice(3, 5), 10);
        if (isNaN(hours) || isNaN(minutes)) return 0;
        return sign * (hours * 60 + minutes);
      }

      var shopOffsetMinutes = parseOffsetToMinutes(shopOffsetStr);

      function parseShopLocalTimeToUTC(endStr, offsetMinutes) {
        endStr = endStr.replace('T', ' ').trim();
        var parts = endStr.split(' ');
        if (parts.length < 2) return NaN;

        var dateBits = parts[0].split('-');
        if (dateBits.length !== 3) return NaN;

        var year = parseInt(dateBits[0], 10);
        var month = parseInt(dateBits[1], 10);
        var day = parseInt(dateBits[2], 10);

        var timeBits = parts[1].split(':');
        var hour = parseInt(timeBits[0], 10);
        var minute = parseInt(timeBits[1] || '0', 10);
        var second = parseInt(timeBits[2] || '0', 10);

        if ([year, month, day, hour, minute, second].some(isNaN)) return NaN;

        var localMillis = Date.UTC(year, month - 1, day, hour, minute, second);
        return localMillis - offsetMinutes * 60 * 1000;
      }

      var endUTC = parseShopLocalTimeToUTC(endTimeStr, shopOffsetMinutes);
      if (isNaN(endUTC)) return;

      var daysEl = timerEl.querySelector('.js-countdown-days');
      var hoursEl = timerEl.querySelector('.js-countdown-hours');
      var minutesEl = timerEl.querySelector('.js-countdown-minutes');
      var secondsEl = timerEl.querySelector('.js-countdown-seconds');
      var endedMessageEl = container.querySelector('.js-countdown-ended');

      function pad(num) {
        return num < 10 ? '0' + num : String(num);
      }

      function updateCountdown() {
        var nowUTC = Date.now();
        var distance = endUTC - nowUTC;

        if (distance <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';

          timerEl.style.opacity = '0.5';
          if (endedMessageEl) endedMessageEl.style.display = 'block';

          clearInterval(intervalId);
          return;
        }

        var totalSeconds = Math.floor(distance / 1000);
        var days = Math.floor(totalSeconds / 86400);
        totalSeconds -= days * 86400;

        var hours = Math.floor(totalSeconds / 3600);
        totalSeconds -= hours * 3600;

        var minutes = Math.floor(totalSeconds / 60);
        var seconds = totalSeconds - minutes * 60;

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      updateCountdown();
      var intervalId = setInterval(updateCountdown, 1000);
    });
})


/**
 * 变体弹窗切换变体图片
 */
document.addEventListener('watt:prod:var:changed', function(data) {
    if (data && data.detail) {
        const selectedVariant = data.detail.selectedVariant || null
        const root = data.detail.root || null
        if(!selectedVariant || !root) return
        const asideImage = root.querySelector('[data-watt-var-img]')
        if (!asideImage) return
        if(selectedVariant.featured_media && selectedVariant.featured_media.preview_image && selectedVariant.featured_media.preview_image.src != null) {
          asideImage.src = selectedVariant.featured_media.preview_image.src
          asideImage.alt = selectedVariant.featured_media.alt || ''
        } 
    }
})

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('.watt-search__predresult');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );

    this.rootPath = '/'
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      this.rootPath = window.Shopify.routes.root
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const q = encodeURIComponent(searchTerm.trim());
    fetch(this.rootPath + `search/suggest?q=${q}` +
      `&resources[limit]=6` +
      `&resources[limit_scope]=each` +
      `&resources[type]=product,collection,page,article` +
      `&section_id=predictive-search`
    )
    .then((response) => {
        if (!response.ok) {
          return response.json().then((res) => {
            var error = new Error(res.message || 'Search request failed');
            this.close();
            throw error;
          });
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        document.dispatchEvent(new CustomEvent('watt:fetch:error', { detail: error }));
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    this.dispatchEvent(new CustomEvent('pred-search-has-value', { bubbles: true }));
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.dispatchEvent(new CustomEvent('pred-search-is-empty', { bubbles: true }));
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    }, 600);
  }
}

customElements.define('predictive-search', PredictiveSearch);




/**
 * 全局第三方代码区域
 * */
document.addEventListener('DOMContentLoaded', function() {
  // impact 跨站点追踪的需求
  try {
    const imRef = new URLSearchParams(window.location.search).get('im_ref');
    if (!imRef) return;

    function processGlobalMenu() {
      const widget = document.querySelector('watt-global-menu-widget');
      if (!widget || !widget.shadowRoot) return false;

      const links = widget.shadowRoot.querySelectorAll('.watt-global-menu-dropdown__link');
      links.forEach(link => {
        const url = new URL(link.href);
        if (!url.searchParams.has('im_ref')) {
          url.searchParams.set('im_ref', imRef);
          link.href = url.toString();
        }
      });
      return true;
    }

    if (!processGlobalMenu()) {
      const observer = new MutationObserver(() => {
        if (processGlobalMenu()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 3000);
    }
  } catch (err) {
    // 捕获异常，防止整个脚本崩溃
    console.error('Global Menu Script Error:', err);
  }
});
